import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider, PlatformConfig, ILogger, ICurrentRouteInfo, ViewerModel } from '@wix/thunderbolt-symbols'
import { CurrentRouteInfoSymbol, LoggerSymbol, ViewerModelSym } from '@wix/thunderbolt-symbols'
import type { IUrlDefinition } from '@wix/viewer-service-url/definition'
import { UrlDefinition as definition } from '@wix/viewer-service-url/definition'
import { UrlService as impl } from '@wix/viewer-service-url/implementations'
import { queryParamsWhitelist } from '@wix/thunderbolt-commons'

export const urlService: FactoryWithDependencies<ServiceProvider<IUrlDefinition, typeof impl>> = withDependencies(
	[LoggerSymbol, CurrentRouteInfoSymbol, ViewerModelSym],
	(
		logger: ILogger,
		currentRouteInfo: ICurrentRouteInfo,
		viewerModel: ViewerModel
	): ServiceProvider<IUrlDefinition, typeof impl> => {
		const config = {
			requestUrl: viewerModel.requestUrl,
			externalBaseUrl: viewerModel.site.externalBaseUrl,
			queryParamsWhitelist,
			logger,
			currentRouteInfo,
		}
		return {
			definition,
			impl,
			config,
			platformConfig: config as any as PlatformConfig,
			hasNonSerializablePlatformConfig: true,
		}
	}
)

export { definition, impl }
